// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".centering[data-v-6e80f276]{display:flex;justify-content:center;align-items:center}.notion[data-v-6e80f276]{font-size:8px}.emphasized[data-v-6e80f276]{color:red}", ""]);
// Exports
module.exports = exports;
